/* eslint no-console:0 */

import 'common';
import '@react/data_display';
import SvelteMount from 'common/svelte-mount';

import '@svelte/common/App.scss';
import common from '@svelte/common';

import CancelPage from '@svelte/cancel_page/CancelPage.svelte';
import invitation_response from '@svelte/invitation_response';

// console.log('application.ts', SvelteMount.registeredComponents)
SvelteMount.setup({
	...common,

	CancelPage,
	...invitation_response,
});
// console.log('application.ts: finished: registeredComponents', SvelteMount.registeredComponents)
//
